var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":_vm.speech_details,"alt":"","width":"100%"}})
}
var staticRenderFns = []

export { render, staticRenderFns }